import { render, staticRenderFns } from "./StayCard.vue?vue&type=template&id=8870d68e&"
import script from "./StayCard.vue?vue&type=script&lang=js&"
export * from "./StayCard.vue?vue&type=script&lang=js&"
import style0 from "./StayCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8870d68e', component.options)
    } else {
      api.reload('8870d68e', component.options)
    }
    module.hot.accept("./StayCard.vue?vue&type=template&id=8870d68e&", function () {
      api.rerender('8870d68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StayCard.vue"
export default component.exports